<template>    
  <v-tabs
      v-model="active"
      color="secondary"
      slider-color="primary"
      
      grow
        centered
    >
      <v-tab
        v-for="seccion in secciones"
        :key="seccion.id"
        ripple
        class="black--text"

        
        
      >
        {{ $t(seccion.titulo)}}

      </v-tab>
      <v-tab-item 
      >
        <v-card flat>
          <Condiciones :simplificada="true"  :soyAlquiler="soyAlquiler" ></Condiciones>
        </v-card>
      </v-tab-item>
      <v-tab-item 
      >
        <v-card flat>
          <Kyc :simplificada="true"></Kyc>
        </v-card>
      </v-tab-item>
      <v-tab-item flat v-if="!getActual.alquiler && getActual.generarContratoKyc == 1"
      >
        <v-card >
          <FirmaSimplificada :active="active"></FirmaSimplificada>
        </v-card>
      </v-tab-item>
      <v-tab-item 
      >
        <v-card flat>
          <Documentacion :simplificada="true"></Documentacion>
        </v-card>
      </v-tab-item>
      <v-tab-item flat 
      >
        <v-card flat>
          <FirmaSimplificada :contrato="true" :active="active"></FirmaSimplificada>
        </v-card>
      </v-tab-item>
  </v-tabs>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Condiciones from '@/components/reservas/condiciones/Condiciones';
import Kyc from '@/components/reservas/kyc/Kyc';
import FirmaSimplificada from '@/components/reservas/kyc/FirmaSimplificada';
import Documentacion from '@/components/reservas/documentacion/Documentacion';

export default {
components: {
 Kyc, Documentacion, FirmaSimplificada, Condiciones
},
data () {
  return {
   active:1,
   secciones: [
   {
     titulo:'configuracion.moduloCondiciones',
     id: 0
    },
    {
     titulo:'configuracion.moduloKyc',
     id: 1
    },
    {
     titulo:'configuracion.kyc',
     id: 2
    },
    {
     titulo:'configuracion.moduloDoc',
     id: 3
    },
    {
     titulo:'configuracion.moduloContrato',
     id: 4
    }
   ]
  }
},
async created () {
  if (this.getActual.alquiler || this.getActual.generarContratoKyc == 0) {
    this.secciones = this.secciones.filter(x => x.id != 2)
  }

},
computed: {
  ...mapGetters({
    reserva: 'reservas/_id/getActual',
    getActual: 'modulosOrdenes/getActual',
    getall: 'modulosOrdenes/modulos/getAll'
  }),
  soyAlquiler () {
    return this.getActual.alquiler
  }
},
methods: {
  ...mapActions({
    addAlert: 'alerts/add',
  })
}
}
</script>



// WEBPACK FOOTER //
// src/components/reservas/simplificada/Simplificada.vue